import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import grey from "@mui/material/colors/grey";
import { useSx } from "./Accordion.styles";
const Accordion = ({ color = grey[500], summary, children, ...props }) => {
    const sx = useSx({ color });
    return (_jsxs(MuiAccordion, { sx: sx.accordionSx, ...props, children: [_jsx(AccordionSummary, { sx: sx.accordionSummarySx, expandIcon: children ? _jsx(ExpandMoreIcon, {}) : null, children: summary }), children && (_jsx(AccordionDetails, { sx: sx.accordionDetailsSx, children: children }))] }));
};
export default Accordion;
